<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_customer.new') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">

                        <create-customer-form :customer="customer" :smart_values="smart_values" :smart_states="smart_states" :smart_loaded="smart" ref="customer_form"></create-customer-form>
                        
                    </v-form>
                    <v-row class=" py-0 mt-2" justify="center" align="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('edit_customer.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission:any="'client.create|client.edit'">
                                {{ $t('edit_customer.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import { editCustomerUseCase } from '../application/use_cases/edit_customer_use_case';
import { createSmartValuesUseCase } from '../application/use_cases/create_smart_values_use_case';
import { getSmartValuesUseCase } from '../application/use_cases/get_smart_values_use_case';
import { HttpCustomerRepository } from '../infrastructure/customer_repository';
import { indexWarehousesUseCase } from '../../warehouses/application/use_cases/index_warehouse_use_case';
import { HttpWarehouseRepository } from '../../warehouses/infrastructure/repositories/warehouse_repository';

import { indexShippingAccountsUseCase } from '../../shipping_accounts/application/use_cases/index_shipping_accounts_use_case';
import { HttpShippingAccountsRepository } from '../../shipping_accounts/infrastructure/repositories/shipping_account_repository';

export default {
    computed: {},
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            customer: {
                name: "",
                social_reason: "",
                country: "",
                state: "",
                neighborhood: "",
                street: "",
                zipcode: "",
                external_number: "",
                internal_number: "",
                municipality: "",
                contact_phone: "",
                service_phone: "",
                email: "",
                is_national: 1,
                immex_ssn: '',
                rfe_idc: '',
                language: 'es',
                warehouses: [],
                fulfillment: 0,
                return_label: 0,
                shipments_notifications: 1,
                shipping_accounts: [],
                email_to_notify: [],
                in_out_ad: 0,
                arrival_ad: 0,
                ramping_ad: 0,
                start_process_ad: 0,
                end_process_ad: 0,
                exit_truck_ad: 0,
                outcome_confirmation_ad: 0,
                operations_by_customer_ad: 0,
                stock_ad: 0,
                storage_policies_ad: 0,
                prepared_orders_ad: 0,
                operations_by_customer_time: "",
                stock_time: "",
                avoid_validations: false,
                rfid_by_product: 0,
                hd_services: 0,
                picking_required: 0,
                guides_service: false,
                client_type: "DEFAULT",
                clients_warehouse: [],
                operation_notifications: false,
                cutoff_time: '',
            },  
            smart: false,
            smart_values: {},
            smart_states: ["Aguascalientes" ,"Baja California" ,"Baja California Sur" ,"Campeche" ,"Chiapas" ,"Chihuahua" ,"Ciudad De Mexico" ,"Coahuila" ,"Colima" ,"Durango" ,"Guanajuato" ,"Guerrero" ,"Hidalgo" ,"Jalisco" ,"Estado De Mexico" ,"Michoacan" ,"Morelos" ,"Nayarit" ,"Nuevo Leon" ,"Oaxaca" ,"Puebla" ,"Queretaro" ,"Quintana Roo" ,"San Luis Potosi" ,"Sinaloa" ,"Sonora" ,"Tabasco" ,"Tamaulipas" ,"Tlaxcala" ,"Veracruz" ,"Yucatan" , "Zacatecas"]
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.edit_customer";
    },
    methods: {
        async index(){
            this.smart_states.forEach( x => {
                this.smart_values[x] = { option_1: '', option_2: '', option_3: '' };
            });
            // Get countries
            const lsToken = localStorage.getItem("access_token");
            this.$store.state.loaderProps.visible = true;
            this.$http.get('https://locations.intech.mx/api/getCountries')
            .then((response) => {
                this.countries = response.data
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })

            try {
                // Get current customer
                const response = await this.$http.get(this.$store.state.chronosApi + 'clients/' + this.id, {headers: {Authorization: lsToken}})
                
                this.customer = response.data.data.attributes;
                console.log(this.customer.cutoff_time)
                this.customer.operation_notifications = false;

                if(response.data.data.attributes.client_type == "HD") this.customer.hd_services = true;
                else if(response.data.data.attributes.client_type == "DEFAULT") this.customer.hd_services = false;
                
                this.customer.client_type = response.data.data.attributes.client_type;

                this.customer.country = response.data.data.attributes.country;
                this.customer.clients_warehouse = response.data.data.attributes.clients_warehouse;
            
                this.customer.shipping_accounts.forEach(y => {
                    y.value = true;
                })
            
                if(this.customer.fulfillment == "cod") this.customer.fulfillment = 1;
                else if(this.customer.fulfillment == "regular") this.customer.fulfillment = 2;
                else if(this.customer.fulfillment == "all") this.customer.fulfillment = 3;
                else if(this.customer.fulfillment == "none") this.customer.fulfillment = 0;

                if(this.customer.is_national == "both") this.customer.is_national = 2;
                else if(this.customer.is_national == "national") this.customer.is_national = 1;
                else if(this.customer.is_national == "international") this.customer.is_national = 0;
                
                if(response.data.data.attributes.email_to_notify != null) this.customer.email_to_notify = response.data.data.attributes.email_to_notify.split(",");
    
                if(this.customer.in_out_ad || this.customer.arrival_ad || this.customer.ramping_ad || this.customer.start_process_ad || this.customer. end_process_ad || this.customer.exit_truck_ad || this.customer.operations_by_customer_ad || this.customer.stock_ad || this.customer.storage_policies_ad || this.customer.outcome_confirmation_ad) this.customer.operation_notifications = true;
            }
            catch(e){
                console.log(e)
            }

            try {
                const res = await getSmartValuesUseCase(this.id, HttpCustomerRepository);
                
                if(res.data.data != null){
                    this.smart_values = res.data.data.attributes.preferences;
                    this.smart = true;
                }
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data
                }
            }

            try {
                const shipping_accounts = await indexShippingAccountsUseCase(HttpShippingAccountsRepository);


                for(var j in shipping_accounts.data.data){
                    var s = this.customer.shipping_accounts.find(item => item.id == shipping_accounts.data.data[j].attributes.id);

                    if(s != undefined) s.value = true;
                    else this.customer.shipping_accounts.push({ name: shipping_accounts.data.data[j].attributes.name, value: false, service_type: shipping_accounts.data.data[j].attributes.service_type })
                }
            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response
                }
            } 

            try {
                this.customer.warehouses = [];
                const warehouses = await indexWarehousesUseCase(HttpWarehouseRepository);

                for(var i in warehouses){
                    var w = this.customer.clients_warehouse.find(item => item.warehouse_id == warehouses[i].id);

                    if(w != undefined) {
                        this.customer.warehouses.push({ name: warehouses[i].name, value: true, is_rfid: w.is_rfid });
                        
                        if(w.is_rfid == true) this.is_rfid = true;
                    }
                    else this.customer.warehouses.push({ name: warehouses[i].name, value: false, is_rfid: false });
                }
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response
                }
            } 
        },
        async save(){
            const validate = this.$refs.form.validate();
            var at_least_one_warehouse = false;

            this.customer.warehouses.forEach(x => {
                if(x.value == true) at_least_one_warehouse = true;
            });

            if(validate && at_least_one_warehouse){
                if(this.customer.hd_services == true) this.customer.client_type = "HD";

                if(this.customer.operation_notifications == false) {
                    this.customer.in_out_ad = false;
                    this.customer.arrival_ad = false;
                    this.customer.ramping_ad = false;
                    this.customer.start_process_ad = false; 
                    this.customer. end_process_ad = false; 
                    this.customer.exit_truck_ad = false; 
                    this.customer.operations_by_customer_ad = false; 
                    this.customer.stock_ad = false; 
                    this.customer.storage_policies_ad = false;
                }

                this.customer['settings'] = this.settings;

                try {
                    const res = await editCustomerUseCase(this.id, this.customer, HttpCustomerRepository);
    
                    if(res.status === 201 || res.status == 200){
                        try {
                            const res_smart = await createSmartValuesUseCase(res.data.id, { states: this.$refs.customer_form.smart_values }, HttpCustomerRepository);
                            res_smart;

                            this.snackbar = {
                                visible: true,
                                color: 'success2',
                                text: this.$t('create_custom_agent.responses.success')
                            }
                            this.$router.push({ name: "CustomersIndex" });  
                        } catch (e) {
                            console.log(e);
                            this.snackbar = {
                                visible: true,
                                color: 'error',
                                text: e.response == null? e : e.response
                            }
                        }
                    }
                } catch (e) {
                    console.log(e);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response
                    }
                }
            }
            else {
                this.$store.state.loaderProps.visible = false;
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('edit_customer.invalid_form')
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
        
    }
}
</script>

<style lang="css">
</style>